import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class EmailContentService {
  private api = inject(ApiService);

  get() { return this.api.get('/email_content'); }
  getOne(id: number) { return this.api.get(`/email_content/${id}`); }
  upsert(json: any) { return this.api.post('/email_content', json); }
  updateStatus(json: any) { return this.api.post('/email_content/status', json); }
}
